import React from 'react'
import Profile from '../pages/Profile'
import AddOrganizationUser from '../pages/ManageOrganizationUsers/addOrganizationUser'
import UpdatePassword from '../pages/auth/LoginForm/Components/UpdatePassword'
import ViewOrganizationUser from '../pages/ManageOrganizationUsers/ViewOrganizationUser'
import EditOrganizationUser from '../pages/ManageOrganizationUsers/EditOrganizationUser'
import ManageOrganizationUsers from '../pages/ManageOrganizationUsers'
import ManagePatients from '../pages/ManagePatient/index.jsx'
import PatientIndex from '../pages/ManagePatient/AddPatient/index.jsx'
import ResetPassword from '../pages/auth/LoginForm/Components/ResetPassword.jsx'
import ViewPatient from '../pages/ManagePatient/ViewPatient/index.jsx'
import AddManageMonitoringCondTemplateIndex from '../pages/ManageMonitoringConditionsTemplates/addTemplateIndex.jsx'
import ManageMonitoringConditionTemplates from '../pages/ManageMonitoringConditionsTemplates/index.jsx'
import ViewMonitorConditionTemplate from '../pages/ManageMonitoringConditionsTemplates/viewMonitotingTemplate.jsx'
import AddObserverDetails from '../pages/ManageObserver/AddObserver.jsx'
import ManageObserver from '../pages/ManageObserver/index.jsx'
import ViewObserver from '../pages/ManageObserver/ViewObserver.jsx'
import ManageObserverActivityHistory from '../pages/ManageObserver/Components/ManageObserverActivityHistory/Index.jsx'
import ManagePatientActivityHistory from '../pages/ManagePatient/Component/ManagePatientActivityHistory/Index.jsx'
import ManagePatientExportHistory from '../pages/ManagePatient/Component/ManagePatientExportHistory/Index.jsx'
import ManageImport from '../pages/ManageImport/index.jsx'
import ManageOrganizationUserActivityHistory from '../pages/ManageOrganizationUsers/ManageExportHistory/index.jsx'
import ManageUploadFile from '../pages/ManageTransferFile/index.jsx'

export const ComponentsBasedOnRole = {
    "admin":
        [
            {
                name: 'Profile',
                element: <Profile />,
                path: '/profile',
                roleKey: 'Profile',
            },
            {
                name: 'Profile',
                element: <Profile />,
                path: '/',
                roleKey: 'Profile',
            },
            {
                name: 'Reset',
                element: <ResetPassword />,
                path: '/reset',
                roleKey: 'Reset',
            },
            {
                name: 'Manage Organization Users',
                element: <ManageOrganizationUsers />,
                path: '/manage-organization-users',
                roleKey: 'OrganizationUsers'

            },
            {
                name: 'Update Password',
                element: <UpdatePassword />,
                path: '/profile/update-password',
                roleKey: 'UpdatePassword'

            },
            {
                name: 'Manage Organization Users',
                element: <AddOrganizationUser />,
                path: 'manage-organization-users/addOrganizationUser',
                roleKey: 'OrganizationUsers',
            },
            {
                name: 'Manage Organization Users',
                element: <ViewOrganizationUser />,
                path: '/manage-organization-users/:id',
                roleKey: 'OrganizationUsers'

            },
            {
                name: 'Manage Organization Users',
                element: <EditOrganizationUser edit />,
                path: '/manage-organization-users/edit-organization-user/:id',
                roleKey: 'OrganizationUsers'

            },
            {
                name:'Manage Organizations',
                element:<ManageOrganizationUserActivityHistory />,
                path:'/manage-organization-users/activity_history',
                roleKey : 'Manage-organizations'
    
            },
            {
                name: 'Manage Patients',
                element: <PatientIndex />,
                path: '/manage-patients/add-patient',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Patients',
                element: <PatientIndex edit />,
                path: '/manage-patients/edit-patient/:id',
                roleKey: 'Manage-Patients'

            },
            {
                name: 'Manage Patients',
                element: <ManagePatients />,
                path: '/manage-patients',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Patients',
                element: <ViewPatient />,
                path: '/manage-patients/view-patient/:id',
                roleKey: 'Manage-Patients'

            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <AddManageMonitoringCondTemplateIndex />,
                path: '/manage-monitoring-condition-templates/add-template',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <AddManageMonitoringCondTemplateIndex edit/>,
                path: '/manage-monitoring-condition-templates/add-template/:id',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <ManageMonitoringConditionTemplates />,
                path: '/manage-monitoring-condition-templates',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <ViewMonitorConditionTemplate />,
                path: '/manage-monitoring-condition-templates/:id',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Patients',
                element: <ManagePatientActivityHistory />,
                path: '/manage-patients/activity_history',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Observer',
                element: <AddObserverDetails />,
                path: '/manage-observer/add-observer',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <AddObserverDetails edit />,
                path: '/manage-observer/edit-observer/:id',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ManageObserver />,
                path: '/manage-observer',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ViewObserver />,
                path: '/manage-observer/:id',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ManageObserverActivityHistory />,
                path: '/manage-observer/activity_history',
                roleKey: 'Manage-observer'
            },
            {
                name: 'Manage Patients',
                element: <ManagePatientExportHistory />,
                path: '/manage-patients/activity_history/export-history/',
                roleKey: 'Manage-Patients'
            },
            {
                name:'Manage Patients',
                element:<ManageImport/>,
                path:'/manage-import',
                roleKey : 'Manage-Patients'
            },
            {
                name  : 'Upload File',
                element: <ManageUploadFile/>,
                path : '/upload-file',
                roleKey : 'Upload-File'
            },
        ],
    "user":
        [
            {
                name: 'Profile',
                element: <Profile />,
                path: '/profile',
                roleKey: 'Profile',
            },
            {
                name: 'Profile',
                element: <Profile />,
                path: '/',
                roleKey: 'Profile',
            },
            {
                name: 'Reset',
                element: <ResetPassword />,
                path: '/reset',
                roleKey: 'Reset',
            },
            {
                name: 'Update Password',
                element: <UpdatePassword />,
                path: '/profile/update-password',
                roleKey: 'UpdatePassword'

            },
            {
                name: 'Manage Patients',
                element: <PatientIndex />,
                path: '/manage-patients/add-patient',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Patients',
                element: <PatientIndex edit />,
                path: '/manage-patients/edit-patient/:id',
                roleKey: 'Manage-Patients'

            },
            {
                name: 'Manage Patients',
                element: <ManagePatients />,
                path: '/manage-patients',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Patients',
                element: <ViewPatient />,
                path: '/manage-patients/view-patient/:id',
                roleKey: 'Manage-Patients'

            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <AddManageMonitoringCondTemplateIndex />,
                path: '/manage-monitoring-condition-templates/add-template',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <AddManageMonitoringCondTemplateIndex edit />,
                path: '/manage-monitoring-condition-templates/add-template/:id',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <ManageMonitoringConditionTemplates />,
                path: '/manage-monitoring-condition-templates',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Monitoring Conditions Templates',
                element: <ViewMonitorConditionTemplate />,
                path: '/manage-monitoring-condition-templates/:id',
                roleKey: 'Manage-monitoring-conditions-templates'
            },
            {
                name: 'Manage Patients',
                element: <ManagePatientActivityHistory />,
                path: '/manage-patients/activity_history',
                roleKey: 'Manage-Patients'
            },
            {
                name: 'Manage Observer',
                element: <AddObserverDetails />,
                path: '/manage-observer/add-observer',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <AddObserverDetails edit />,
                path: '/manage-observer/edit-observer/:id',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ManageObserver />,
                path: '/manage-observer',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ViewObserver />,
                path: '/manage-observer/:id',
                roleKey: 'Manage-Observer'
            },
            {
                name: 'Manage Observer',
                element: <ManageObserverActivityHistory />,
                path: '/manage-observer/activity_history',
                roleKey: 'Manage-observer'
            },
            {
                name:'Manage Patients',
                element:<ManageImport/>,
                path:'/manage-import',
                roleKey : 'Manage-Patients'
            },
            {
                name  : 'Upload File',
                element: <ManageUploadFile/>,
                path : '/upload-file',
                roleKey : 'Upload-File'
            },
            {
                name: 'Manage Patients',
                element: <ManagePatientExportHistory />,
                path: '/manage-patients/activity_history/export-history/',
                roleKey: 'Manage-Patients'
            },

        ]
}